import {Record as record} from 'immutable';

export default record(
    {
        index: 0,
        /** default previous Index to index++ as we assume we default
         *  to placing the last slide flex order to be 0 and display to left */
        prevIndex: 5,
        fullScreen: false,
        isVerticalGalleryOpen: false
    },
    'CarouselRecord'
);
